import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PageContainer from "@/components/layouts/PageContainer";
import { Heading } from "@/components/heading";
import { Text } from "@/components/text";
import { Button } from "@/components/button";
import { ArrowLeftIcon } from "@heroicons/react/20/solid";
import { useCreateExamConfig } from "@/apis/exam_configs/createExamConfig";
import type { ICreateExamConfigRequest } from "@/apis/exam_configs/createExamConfig";
import ExamConfigForm from "./components/ExamConfigForm";

const ExamConfigCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const {
    mutate: createExamConfig,
    isPending,
    isError,
    error,
  } = useCreateExamConfig();
  const [serverError, setServerError] = useState<string | undefined>();

  // 폼 제출 핸들러
  const handleSubmit = (formData: ICreateExamConfigRequest) => {
    // API 호출
    createExamConfig(formData, {
      onSuccess: () => {
        // 성공 시 목록 페이지로 이동
        navigate("/exam_configs");
      },
      onError: (error: any) => {
        // 서버 오류 처리
        setServerError(error?.message || "Failed to create exam configuration");
      },
    });
  };

  // 목록 페이지로 돌아가기
  const handleCancel = () => {
    navigate("/exam_configs");
  };

  return (
    <PageContainer>
      <div className="space-y-6">
        <div className="flex items-center gap-4">
          <Button plain onClick={handleCancel}>
            <ArrowLeftIcon className="h-5 w-5" />
            Back
          </Button>

          <div>
            <Heading>Add New Exam Configuration</Heading>
            <Text className="text-zinc-500">
              Create a new exam configuration by specifying the subjects,
              durations, and calculator permissions.
            </Text>
          </div>
        </div>

        {/* 시험 설정 생성 폼 */}
        <div className="p-8 border border-gray-200 rounded-md bg-white">
          <ExamConfigForm
            onSubmit={handleSubmit}
            onCancel={handleCancel}
            isLoading={isPending}
            serverError={serverError}
          />
        </div>
      </div>
    </PageContainer>
  );
};

export default ExamConfigCreatePage;
